import { Directive, ElementRef, Inject } from '@angular/core';
import {
  FlexDirective,
  FlexStyleBuilder,
  LayoutConfigOptions,
  LAYOUT_CONFIG,
  MediaMarshaller,
  StyleUtils
} from '@angular/flex-layout';

const selector = `[fxFlex],
                  [fxFlex.small],
                  [fxFlex.medium],
                  [fxFlex.default],
                  [fxFlex.large]
                  `;

const inputs = ['fxFlex', 'fxFlex.small', 'fxFlex.medium', 'fxFlex.default', 'fxFlex.large'];

@Directive({ selector, inputs })
export class CustomFlexDirective extends FlexDirective {
  constructor(
    elRef: ElementRef,
    styleUtils: StyleUtils,
    @Inject(LAYOUT_CONFIG) layoutConfig: LayoutConfigOptions,
    styleBuilder: FlexStyleBuilder,
    marshal: MediaMarshaller
  ) {
    super(elRef, styleUtils, layoutConfig, styleBuilder, marshal);
  }
  protected inputs = inputs;
}
